const checkoutQueryKeys = {
  all: ["checkout"] as const,
  links: (userId: string) => [...checkoutQueryKeys.all, "links", userId] as const,
};

export default checkoutQueryKeys;
